/*
 * @description: 
 * @Author: Jay
 * @Date: 2023-04-28 09:42:18
 * @LastEditors: Jay
 * @LastEditTime: 2026-03-02 13:44:56
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

//全局 js
import operate from "./utils/operate"
Vue.prototype.$operate = operate

// element-ui 按需引入
import element from './element/index'

//修改默认颜色
import './assets/css/element-variables.scss'
Vue.use(element)

//vue 滑动验证
import SlideVerify from 'vue-monoplasty-slide-verify';
Vue.use(SlideVerify);

// permission 权限控制
import permission from './directives/permission'
Vue.directive('permission', permission)

// 页头信息
import pageHeaderCommon from "./components/pageHeaderModule/pageHeaderCommon.vue";
Vue.component('pageHeaderCommon', pageHeaderCommon);


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
